import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { StoreModule } from '@ngrx/store';

import { AiArcsPreset } from './theme/app-theme';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { DARK_MODE_CLASS } from './theme/constant/theme.constant';
import { IAppState } from './store/interface/app.state.interface';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { TokenStoreService } from './core/services/token-store.service';
import { environment } from '../environments/environment';
import { userReducer } from './store/user/user.reducer';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        LayoutModule,
        StoreModule.forRoot<IAppState>({ user: userReducer }),
    ],
    providers: [
        providePrimeNG({
            license: environment.primeuiLicenseKey,
            theme: {
                preset: AiArcsPreset,
                options: { darkModeSelector: `.${DARK_MODE_CLASS}` },
            },
        }),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        // Before the first page's guards, so a token from Google's callback counts as signed in.
        provideAppInitializer(() => inject(TokenStoreService).saveHandedOverToken()),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
